import { useFeatureIsOn } from '@growthbook/growthbook-react'

import type { TherapistType } from '@/legacy-src/types/TherapistStateType'

import { useIsOfflineAllowedByCompany } from '@/src/domains/client-booking/hooks/useIsOfflineAllowedByCompany'
import { isTherapistOfflineAvailable } from '@/src/domains/therapist/utils/isTherapistOfflineAvailable'

export interface UseIsClientOfflineBookingAvailable {
  therapist: Pick<TherapistType, 'hasOfflineTherapy' | 'office'>
}

export const useIsClientOfflineBookingAvailable = ({ therapist }: UseIsClientOfflineBookingAvailable) => {
  const isOfflineEnabled = useFeatureIsOn('offline-therapy-enable-user-booking')
  const isOfflineAllowedByCompany = useIsOfflineAllowedByCompany()

  return isOfflineEnabled && isTherapistOfflineAvailable(therapist) && isOfflineAllowedByCompany
}
